import React from 'react';
import B2CNotification from './B2cNotification';
import { apiConstants } from '../../common/constants';
import { manageRvpStatusNotifications } from '../../helpers/UtilityHelper';

// B2C reverse (RVP) tab. Same matrix as the forward B2C tab, pointed at the RVP subscription
// (alertSubscriptionRvp) and limited to the pickup event. B2B is out of scope for RVP.
const RvpNotification = () => (
  <B2CNotification
    getEndpoint={apiConstants.GET_SUBSCRIPTION_RVP}
    postEndpoint={apiConstants.POST_SUBSCRIPTION_RVP}
    modules={manageRvpStatusNotifications}
  />
);

export default RvpNotification;
